module.exports = __webpack_public_path__ + "img/inpirationen.529596a3.png";